import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "./ui/button";

export function PaginationBar({
  total,
  page,
  perPage,
  onPageChange,
  onPerPageChange
}: {
  total: number;
  page: number;
  perPage: number;
  onPageChange: (page: number) => void;
  onPerPageChange: (perPage: number) => void;
}) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = total ? (safePage - 1) * perPage + 1 : 0;
  const end = Math.min(total, safePage * perPage);
  return (
    <div className="flex h-10 items-center justify-between gap-2 rounded-md border bg-white px-3 text-xs">
      <div className="text-slate-500">
        {total ? `${start}-${end} / ${total}` : "0 / 0"}
      </div>
      <div className="flex items-center gap-2">
        <span className="text-slate-500">每页</span>
        <select
          className="h-8 rounded-md border border-slate-300 bg-white px-2 text-xs"
          value={perPage}
          onChange={(event) => onPerPageChange(Number(event.target.value))}
        >
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={200}>200</option>
        </select>
        <Button disabled={safePage <= 1} onClick={() => onPageChange(safePage - 1)}>
          <ChevronLeft size={14} />
        </Button>
        <span className="min-w-16 text-center text-slate-600">
          {safePage} / {totalPages}
        </span>
        <Button disabled={safePage >= totalPages} onClick={() => onPageChange(safePage + 1)}>
          <ChevronRight size={14} />
        </Button>
      </div>
    </div>
  );
}
